import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'member/personal/address', // 资源路径
    defaultRels: [], // 默认需要的关联数据
  }

})
